import './share.css';

function dialogSetUpCopyUrlButtons(dialog, shareUrl) {
  const shareButtons = Array.from(dialog.querySelectorAll('.share-button-url'));
  shareButtons.forEach(button => button.addEventListener('click', async (e) => {
    if(typeof navigator.clipboard === "undefined") {
      console.error("[share] Clipboard API is not available. Check if the website is encrypted via HTTPS.");
      return;
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch (error) {
      console.error(error.message);
    }
  }));
}

function dialogSetUpMailShareButtons(dialog, shareMessage, shareEmailSubject) {
  const mailShareLinks = Array.from(dialog.querySelectorAll('.share-button-email'));

  const mailUrl = `mailto:?subject=${encodeURIComponent(shareEmailSubject)}&body=${encodeURIComponent(shareMessage)}`;
  mailShareLinks.forEach(link => link.href = mailUrl);
}
function dialogSetUpWhatsappShareButtons(dialog, shareMessage) {
  const whatsappShareLinks = Array.from(dialog.querySelectorAll('.share-button-whatsapp'));

  const shareUrl = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
  whatsappShareLinks.forEach(link => link.href = shareUrl);
}

async function openShareModal(dialog, isMobile, shareUrl, shareMessageNoUrl) {
  if(isMobile) {
    const shareData = {
      text: shareMessageNoUrl,
      url: shareUrl,
    };
    if(navigator.canShare && navigator.canShare(shareData)) {
      return await navigator.share(shareData);
    }
  }
  dialog.showModal();
}

function setUpShareButtonsDesktop(scope) {
  setUpShareButtons(scope, false);
}

function setUpShareButtonsMobile(scope) {
  setUpShareButtons(scope, true);
}

function setUpShareButtons(scope, isMobile) {
  const shareButtons = Array.from(scope.querySelectorAll('.dataset-share-button'));
  shareButtons.forEach(button => {
    const datasetId = parseInt(button.dataset.dsId);
    const dialog = scope.querySelector('.dataset-share-modal[data-ds-id="' + datasetId + '"]');
    const shareUrl = button.dataset.dsUrl ?? "";
    const shareMessage = (button.dataset.shareMessage ?? "").replaceAll("{share_url}", shareUrl);
    const shareMessageNoUrl = (button.dataset.shareMessage ?? "").replaceAll("{share_url}", "");
    const shareEmailSubject = (button.dataset.shareEmailSubject ?? "");
    dialogSetUpMailShareButtons(dialog, shareMessage, shareEmailSubject);
    dialogSetUpWhatsappShareButtons(dialog, shareMessage);
    dialogSetUpCopyUrlButtons(dialog, shareUrl);
    button.addEventListener('click', e => openShareModal(dialog, isMobile, shareUrl, shareMessageNoUrl))
  });
}

export {setUpShareButtonsDesktop, setUpShareButtonsMobile}
